import React from 'react';
import Icon from '../../../components/AppIcon';

const MLModelIndicator = ({ modelData }) => {
  const getConfidenceColor = (confidence) => {
    if (confidence >= 90) return 'text-success bg-success/10';
    if (confidence >= 70) return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return 'CheckCircle';
      case 'training':
        return 'RefreshCw';
      case 'error':
        return 'AlertCircle';
      default:
        return 'HelpCircle';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success';
      case 'training':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
            Model Machine Learning
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Status dan performa model deteksi fraud
          </p>
        </div>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg ${getStatusColor(modelData?.status)} bg-current/10`}>
          <Icon name={getStatusIcon(modelData?.status)} size={16} className={modelData?.status === 'training' ? 'animate-spin' : ''} />
          <span className="text-xs font-medium">
            {modelData?.status === 'active' ? 'Aktif' : modelData?.status === 'training' ? 'Training' : 'Error'}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="p-4 bg-muted/50 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={16} className="text-primary" />
            <span className="text-xs text-muted-foreground">Akurasi Model</span>
          </div>
          <p className="text-2xl font-semibold text-foreground">{modelData?.accuracy}%</p>
          <p className="text-xs text-success mt-1">+2.3% dari bulan lalu</p>
        </div>

        <div className="p-4 bg-muted/50 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Zap" size={16} className="text-warning" />
            <span className="text-xs text-muted-foreground">Waktu Respons</span>
          </div>
          <p className="text-2xl font-semibold text-foreground">{modelData?.responseTime}ms</p>
          <p className="text-xs text-success mt-1">-15ms dari target</p>
        </div>

        <div className="p-4 bg-muted/50 rounded-xl">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Database" size={16} className="text-accent" />
            <span className="text-xs text-muted-foreground">Data Training</span>
          </div>
          <p className="text-2xl font-semibold text-foreground">{modelData?.trainingDataSize}</p>
          <p className="text-xs text-muted-foreground mt-1">transaksi</p>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Confidence Score</span>
            <span className={`text-sm font-semibold ${getConfidenceColor(modelData?.confidenceScore)}`}>
              {modelData?.confidenceScore}%
            </span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-smooth ${
                modelData?.confidenceScore >= 90 ? 'bg-success' : modelData?.confidenceScore >= 70 ? 'bg-warning' : 'bg-error'
              }`}
              style={{ width: `${modelData?.confidenceScore}%` }}
            ></div>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground mb-3">Fitur Deteksi Aktif:</p>
          <div className="grid grid-cols-2 gap-2">
            {modelData?.activeFeatures?.map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-2 p-2 bg-primary/5 rounded-lg"
              >
                <Icon name="CheckCircle" size={14} className="text-success flex-shrink-0" />
                <span className="text-xs text-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-muted-foreground">Terakhir Diperbarui</span>
            <span className="text-xs font-medium text-foreground">{modelData?.lastUpdated}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Versi Model</span>
            <span className="text-xs font-medium text-foreground">{modelData?.version}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MLModelIndicator;